import {NumberUtil} from "base/utilities";
import {SectionCard, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const SubaglomeracionInventarioTotalSection = ({subaglomeracion}) => {
    return (
        <SectionCard title="Total">
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Lonxitude rede:"
                        value={NumberUtil.formatDecimal(
                            subaglomeracion.stats.lonxitudecolector,
                            3
                        )}
                        unit="Km."
                        tooltipText="Lonxitude da rede unitaria/fecais"
                    />
                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default SubaglomeracionInventarioTotalSection;
